import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

/** Window-local chrome state. No preference write or new keyboard shortcut in S1. */
export const sidebarCollapsedAtom = atom(false);
export const lastAppPathAtom = atom('/');
/**
 * SH-3: THE PHONE'S SETTINGS LIST IS THE "More" SHEET, and a pushed pane needs a way back
 * to it. The sheet was `MobileNav`'s own `useState`, which nothing else could reach; the
 * back chevron in a pane's bar is in `PageHeader`, a different subtree. One atom, two
 * readers, no route: the sheet is still a sheet and no navigation is invented for it.
 */
export const moreSheetOpenAtom = atom(false);

/**
 * THE SIDEBAR'S WIDTH, DRAGGED AND REMEMBERED BY THIS BROWSER (SH-A10, owner-33).
 *
 * A split view's panes resize between a minimum and a maximum and the choice sticks: "Set
 * reasonable defaults for minimum and maximum pane sizes"
 * (https://developer.apple.com/design/human-interface-guidelines/split-views). `null` means
 * "the token's ideal", so the day `--sidebar-width` changes, everyone who never dragged the
 * divider gets the new value instead of a copy of the old one frozen in their browser.
 *
 * WHY THIS BROWSER AND NOT THE PERSON. A width is a preference about LOOKING, the same
 * class as the list pane's own remembered width (P4-2) and as rows per page; the per-user
 * store is a network round trip, and a drag writes on every frame. Moving it to the
 * preference store is a later slice's one-line change.
 */
export const SIDEBAR_WIDTH_KEY = 'ofmos.shell.sidebarWidth';

export const sidebarWidthAtom = atomWithStorage<number | null>(SIDEBAR_WIDTH_KEY, null, undefined, {
  getOnInit: true,
});
